<div class="d-flex justify-content-center align-items-center w-100 h-100 login-container">
    <div class="col-xl-4 col-md-6 col-10">
        <div class="card border-0 box-shadow rounded-0">
            <div class="card-header d-flex justify-content-center logo-bg align-items-center border-0 box-shadow">
                <img class="logo" src="assets/img/app/aladdin-icon-blue.png">
            </div>
            <div class="card-body text-center pb-1">
                <h2>
                    <span *ngIf="showLogin">Login</span>
                    <span *ngIf="showCode">Verification Code</span>
                    <span *ngIf="showPhone">Phone Verification</span>
                </h2>
                <form [formGroup]="form" (ngSubmit)="onSubmit()" class="text-left mt-4" data-testid="login-form">
                    <div [hidden]="!showLogin">
                        <div class="form-group">
                            <input
                                [formControl]="UserName"
                                class="form-control validation-field"
                                placeholder="Email"
                                type="text"
                                autocomplete="username"
                                #usernameField
                                data-testid="login-user-name">
                            <small
                                class="text-danger"
                                *ngIf="form.get('UserName').touched && form.get('UserName').hasError('required')"
                            >
                                Email is required
                            </small>
                        </div>
                        <div class="form-group">
                            <input
                                [formControl]="UserPassword"
                                class="form-control validation-field"
                                placeholder="Password"
                                type="password"
                                autocomplete="current-password"
                                #passwordField
                                data-testid="login-user-password">
                            <small class="text-danger"
                                *ngIf="form.get('UserPassword').touched && form.get('UserPassword').hasError('required')">Password
                                is required</small>
                            <small class="text-danger"
                                *ngIf="form.get('UserPassword').touched && form.get('UserPassword').hasError('minlength')">Password
                                isn't long enough, minimum of 6 characters</small>
                        </div>
                        <div class="d-flex align-center justify-content-between pl-2 mb-4">
                            <div class="d-flex align-center">
                                <input
                                    [(ngModel)]="saveUsername"
                                    [ngModelOptions]="{standalone: true}"
                                    type="checkbox"
                                    id="save-username"
                                    class="d-inline-block"
                                    data-testid="login-remember-username-checkbox">
                                <label class="ml-2 form-check-label font-weight-normal" for="save-username">Remember Username?</label>
                            </div>
                            <div>
                                <a
                                    routerLink="/auth/forgot-password"
                                    [queryParams]="{ email: UserName.value }"
                                    class="forgot-password"
                                    data-testid="login-forgot-password">
                                    Forgot Password?
                                </a>
                            </div>
                        </div>
                    </div>
                    <div [hidden]="!showCode">
                        <div  class=" my-4">
                            Please enter the verification code sent to the number ending in ***{{phoneSuffix}}.
                        </div>
                        <div class="d-flex align-center mb-2">
                            <input placeholder="Verification Code"  [formControl]="MfaCode" type="tel" class="form-control" data-testid="login-mfa-code-tel"/>
                        </div>
                    </div>
                    <div [hidden]="!showPhone" class="px-3">
                        <ul class="my-4">
                            <li>Please provide your mobile number for Multi-Factor Authentication (MFA) to secure your account.</li>
                            <li>Your number remains private and is only used for security verification and essential account alerts.</li>
                        </ul>
                        <div class="d-flex align-center mb-2">
                            <input placeholder="Phone Number" class="text-dark form-control" type="tel" [textMask]="{ mask: phoneMask, guide: false }" [formControl]="NewPhoneNumber" data-testid="login-new-phone-number-tel"/>
                        </div>
                        <div class=" border-top border-bottom border-white my-5 py-2">
                            <div class="d-flex align-items-start">
                                <span class=" px-2">
                                    <input type="checkbox" [formControl]="SmsConsent" data-testid="login-sms-consent-checkbox">
                                </span>
                                <div>
                                    I consent to receive SMS messages from Aladdin.
                                </div>
                            </div>
                            <div class="d-flex align-items-start">
                                <span class=" px-2">
                                    <input type="checkbox" [formControl]="TermsConsent" data-testid="login-terms-consent-checkbox">
                                </span>
                                <div>
                                    <span>I have read and agree to AladdinPortal.com's Terms of Service and </span>
                                    <a class="my-1 text-warning" target="_blank" href="https://aladdincap.com/frequently-asked-questions" data-testid="login-privacy-policy">
                                        Privacy Policy
                                    </a>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="error-message" role="alert" *ngIf="errorMessage">
                        <div class="d-flex flex-nowrap">
                            <span class="fa fa-exclamation-triangle align-self-center mx-2"></span>
                            <span class="mx-1">{{errorMessage}}</span>
                            <span class="fa fa-exclamation-triangle align-self-center mx-2"></span>
                        </div>
                    </div>

                    <div class="form-group">
                        <button
                        [disabled]="!form.valid || isLoading || (showPhone && (!form.value.SmsConsent || !form.value.TermsConsent || !form.value.NewPhoneNumber))"
                        class="btn btn-block silver-lake-blue" type="submit" data-testid="login-sign-in">
                            <span *ngIf="!isLoading && showLogin">Sign In</span>
                            <span *ngIf="!isLoading && showCode">Submit Code</span>
                            <span *ngIf="!isLoading && showPhone">Submit Phone</span>
                            <span *ngIf="isLoading">Please wait...</span>
                        </button>
                    </div>

                    <div class="form-group" *ngIf="showPhone || showCode">
                        <button
                            type="button"
                            [disabled]="!form.valid || isLoading"
                            class="btn btn-block btn-secondary"
                            (click)="startOver()"
                            data-testid="login-back-to-login-page">
                            <i class="fa-regular fa-rotate-left"></i>
                            <span >Back to Login Page</span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
        <app-login-show-app-version></app-login-show-app-version>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/auth/login/login.component.html